(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["of-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-of-quick-view-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.target);
      if (dialog) dialog.showModal();
      return;
    }

    const closer = event.target.closest('[data-of-quick-view-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('of-quick-view')) {
      const rect = event.target.getBoundingClientRect();
      const inBounds =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!inBounds) event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
